module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture8-4c366b0f8afae8ad2fcc2c518fd89ae1.jpg";